import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const HomeAPI = createApi({
    reducerPath: "HomeAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: BaseUrl,
        prepareHeaders: (headers, { endpoint }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            headers.set("Accept", "application/json");
            if (!["addBanner", "updateBanner", "addOtherPageBanner", "updateOtherBanner", "HomeAddSections", "HomeUpdateSections", "HomeAddStaticSection", "HomeUPdateStaticSection"].includes(endpoint)) {
                headers.set("Content-Type", "application/json");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        addBanner: builder.mutation({
            query: (formData) => ({
                url: "admin/banners",
                method: "POST",
                body: formData,
            }),
        }),
        updateBanner: builder.mutation({
            query: ({ formData, id }) => ({
                url: `admin/banners/${id}`,
                method: "POST",
                body: formData,
            }),
        }),

        getBannerList: builder.query({
            query: () => `banners/list-banners`,
        }),

        getBannerbyId: builder.query({
            query: (id) => `banners/show/${id}`,
        }),

        deleteBanner: builder.mutation({
            query: (id) => ({
                url: `admin/banners/${id}`,
                method: "DELETE",
            }),
        }),

        addOtherPageBanner: builder.mutation({
            query: (formData) => ({
                url: "admin/page/store-page-banner",
                method: "POST",
                body: formData,
            }),
        }),

        updateOtherBanner: builder.mutation({
            query: ({ formData, id }) => ({
                url: `admin/page/${id}`,
                method: "POST",
                body: formData,
            }),
        }),

        listAllOtherBanners: builder.query({
            query: () => `page/list-page-banner`,
        }),
        getOtherBannerById: builder.query({
            query: (id) => `page/show/${id}`,
        }),

        deleteOtherBanner: builder.mutation({
            query: (id) => ({
                url: `admin/page/${id}`,
                method: "DELETE",
            }),
        }),
        HomeListSections: builder.query({
            query: () => `/home-sections`,
        }),
        HomeGetSectionById: builder.query({
            query: (id) => `home-sections/${id}`,
        }),
        HomeAddSections: builder.mutation({
            query: (formData) => ({
                url: "admin/sections/store-section",
                method: "POST",
                body: formData,
            }),
        }),
        HomeDeleteSection: builder.mutation({
            query: (id) => ({
                url: `admin/sections/${id}`,
                method: "DELETE",
            }),
        }),

        HomeUpdateSections: builder.mutation({
            query: ({ formData, id }) => ({
                url: `admin/sections/${id}`,
                method: "POST",
                body: formData,
            }),
        }),

        HomeAddStaticSection: builder.mutation({
            query: ({ formData }) => ({
                url: "admin/home-static",
                method: "POST",
                body: formData,
            }),
        }),

        HomeUPdateStaticSection: builder.mutation({
            query: ({ formData, id }) => ({
                url: `admin/home-static/${id}`,
                method: "POST",
                body: formData,
            }),
        }),

        HomeListStaticSection: builder.query({
            query: () => `home-static`,
        }),
        EnableDisableBrand: builder.mutation({
            query: (formData) => ({
                url: `admin/brands/brand-bar-status`,
                method: "POST",
                body: formData,
            }),
        }),

        DisaplayBrandStatus: builder.query({
            query: () => `brands/brand-bar-status`,
        }),

    }),
});

export const { useAddBannerMutation, useDeleteBannerMutation, useGetBannerListQuery, useUpdateBannerMutation, useGetBannerbyIdQuery, useAddOtherPageBannerMutation, useUpdateOtherBannerMutation, useListAllOtherBannersQuery, useDeleteOtherBannerMutation, useGetOtherBannerByIdQuery, useHomeAddSectionsMutation, useHomeListSectionsQuery, useHomeGetSectionByIdQuery, useHomeUpdateSectionsMutation, useHomeDeleteSectionMutation, useHomeAddStaticSectionMutation, useHomeListStaticSectionQuery, useHomeUPdateStaticSectionMutation , useEnableDisableBrandMutation , useDisaplayBrandStatusQuery} = HomeAPI;
